import React, {useContext, useEffect, useState} from 'react';
import ContentCard from './ContentCard';
import OrElement from './OrElement';
import { UserContext } from '../contexts/user-context';
import { withTranslation, Trans } from 'react-i18next';
import AzureLogo from '../../assets/images/ms-symbol.png';
import {Link} from "react-router-dom";

function UserSignInComponent(props) {

  const userContext = useContext(UserContext)

  const sso_providers = userContext.sso_providers;
  const allow_username_password = userContext.allow_username_password;
  const old_oauth_flow_link = userContext.old_oauth_flow_link;
  const use_old_oauth_flow = userContext.use_old_oauth_flow;

  const email = (sso_providers && sso_providers.length > 0) ? '' : userContext.user.email;
  const [allValues, setAllValues] = useState({
    email: email,
    password: '',
    otp_attempt: ''
  });

  useEffect(() => { setAllValues({...allValues, ['email']: email})}, [email] )

  const formClassName = userContext.errors != null ? 'mt-5' : 'mt-5 was-validated';
  const hasSignInErrors = (userContext.errors != null && userContext.errors.signInErrors != null);
  const emailInputClass = hasSignInErrors ? 'form-control is-invalid' : 'form-control';
  const passwordInputClass = hasSignInErrors ? 'form-control is-invalid' : 'form-control';
  const otpInputClass = hasSignInErrors ? 'form-control is-invalid' : 'form-control';

  const showOtp = (userContext.errors != null && userContext.errors.request_otp_challenge != null);

  const changeHandler = e => {
    setAllValues({...allValues, [e.target.name]: e.target.value})
  }

  const sso_providers_layout = () => {
    return (
      <>
        {(sso_providers.length > 0) &&
        <>
          {sso_providers.map((sso_provider) => (
            <div className="mb-5" key={sso_provider.id}>
              {sso_provider.name == "Azure" ?
                <button
                  className="sso-button sso-button--azure"
                  type="button"
                  onClick={() => userContext.loginSso(sso_provider.url)}>
                  <img alt="Azure Logo" src={AzureLogo} className="sso-button__icon" />
                  Sign in with Microsoft
                </button>
                :
                <button
                  className="btn btn-primary btn-lg w-100 mt-2"
                  type="button"
                  onClick={() => userContext.loginSso(sso_provider.url)}
                  key={sso_provider.id}>
                  {sso_provider.name}
                </button>
              }
            </div>
          ))}
        </>
        }
      </>
    );
  }

  const old_sso_providers_layout = () => {
    return (
      <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto">
        <a href={old_oauth_flow_link} className="sso-button-blue btn btn-lg w-100">
          Sign in with SSO
        </a>
      </div>
    );
  }

  const login_layout = () => {
    return (
      <form className={formClassName}
          onSubmit={(event) => {
            event.preventDefault()
            event.stopPropagation()
            userContext.login(allValues.email, allValues.password, allValues.otp_attempt) }}>
        <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
        <div className="form-floating my-3" >
          <input
            type="email"
            name="email"
            value={allValues.email}
            onChange={changeHandler}
            className={emailInputClass}
            id="email"
            placeholder="name@example.com" />
          <label htmlFor="email"><Trans i18nKey="email_address" /></label>

        </div>
        <div className="form-floating my-3" >
          <input
            type="password"
            name="password"
            value={allValues.password}
            onChange={changeHandler}
            className={passwordInputClass}
            id="password"
            placeholder="password" />
          <label htmlFor="password"><Trans i18nKey="password" /></label>
        </div>
        {showOtp &&
          <div className="form-floating my-3" >
            <input
              type="number"
              name="otp_attempt"
              value={allValues.otp_attempt}
              onChange={changeHandler}
              className={otpInputClass}
              id="otp_attempt"
              placeholder="Otp" />
            <label htmlFor="otp_attempt"><Trans i18nKey="otp_attempt" /></label>
          </div>
        }
        {hasSignInErrors &&
        <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto invalid-feedback">
          {userContext.errors.signInErrors.map((error) => (
            <span key={error}><Trans i18nKey={error} /></span>
          ))}
        </div>
        }
        <div className="mt-4 mb-3 d-grid gap-2 col-9 w-100 mx-auto">
          <button className="btn btn-primary btn-lg" type="submit">
            <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="sign_in" />
          </button>
        </div>
        <Link to="/users/password/new" className="link text-center mt-4 mb-3 d-block mx-auto"><Trans i18nKey="password_forgotten" /></Link>
      </form>
    );
  }

  if (use_old_oauth_flow && allow_username_password){
    return (
      <ContentCard title={<Trans i18nKey="sign_in_account" />} >
        {login_layout()}
        <div className="col-9 mx-auto"><OrElement /></div>
        {old_sso_providers_layout()}
      </ContentCard>
    );
  }

  if (use_old_oauth_flow){
    return (
      <ContentCard title={<Trans i18nKey="sign_in_account" />} >
        {old_sso_providers_layout()}
      </ContentCard>
    );
  }

  if (allow_username_password) {
    return (
      <ContentCard title={<Trans i18nKey="sign_in_account" />} >
        {sso_providers_layout()}
        {sso_providers.length > 0 &&
          <div className="col-9 mx-auto"><OrElement/></div>
        }
        {login_layout()}
      </ContentCard>
    );
  }

  return (sso_providers != null && sso_providers.length > 0) ? (
    <ContentCard title={<Trans i18nKey="sign_in_sso" />} >
      {sso_providers_layout()}
    </ContentCard>
  ) : (
    <ContentCard title={<Trans i18nKey="sign_in_account" />} >
      {login_layout()}
    </ContentCard>
  );
}

export default withTranslation()(UserSignInComponent);
